const p2pFieldLabels = {
  oneXTwo: "Match Result",
  firstHalf: "First Half",
  secondHalf: "Second Half",
  fullTime: "Full Time",
  halfTime: "Half Time",
  doubleChance: "Double Chance",
  bothTeamsToScore: "Both Teams to Score",
  overUnderGoals: "Over/Under Goals",
  halfTimeFullTime: "Half Time/Full Time",
  oneXTwoAndOverUnder: "Match Result & Over/Under",
  correctScore: "Correct Score",
  cleanSheet: "Clean Sheet",
  totalGoalsExact: "Total Goals Exact",
  oddEven: "Odd/Even",
  teamToScore: "Team to Score",
  halfWithMoreGoals: "Half with More Goals",
  winToNil: "Win to Nil",
  drawNoBet: "Draw No Bet",
  doubleChanceAndBothTeamsToScore: "Double Chance & Both Teams to Score",
  homeTeam: "Home Team",
  awayTeam: "Away Team",
  lastThreeWay: "Last to Score",
  yes: "Yes",
  no: "No",
  odd: "Odd",
  even: "Even",
  noGoal: "No Goal",
  bothTeams: "Both Teams",
  over1_5: "Over 1.5",
  under1_5: "Under 1.5",
  over2_5: "Over 2.5",
  under2_5: "Under 2.5",
  over3_5: "Over 3.5",
  under3_5: "Under 3.5",
  over4_5: "Over 4.5",
  under4_5: "Under 4.5",
  over5_5: "Over 5.5",
  under5_5: "Under 5.5",
  over0_5: "Over 0.5",
  under0_5: "Under 0.5",
};

export function labelForP2PField(key) {
  if (!key) return "";
  const label = p2pFieldLabels[key] || key;
  return String(label).replace(/\s[-–—]\s/g, ", ");
}

export default p2pFieldLabels;
